import { NgModule } from '@angular/core';
import { BrandRouterLinkDirective } from './brand-router-link.directive';
import { BrandSettingsRouterLinkDirective } from './brand-settings-router-link.directive';
import { PracticeRouterLinkDirective } from './practice-router-link.directive';
import { PracticeSettingsRouterLinkDirective } from './practice-settings-router-link.directive';
import { StateBasedNavigationService } from './state-based-navigation.service';
import { TimelineNavigationService } from './timeline-navigation-service';

@NgModule({
  imports: [
    BrandRouterLinkDirective,
    BrandSettingsRouterLinkDirective,
    PracticeRouterLinkDirective,
    PracticeSettingsRouterLinkDirective,
  ],
  exports: [
    BrandRouterLinkDirective,
    BrandSettingsRouterLinkDirective,
    PracticeRouterLinkDirective,
    PracticeSettingsRouterLinkDirective,
  ],
  providers: [StateBasedNavigationService, TimelineNavigationService],
})
export class NavigationModule {}
